module.exports = __webpack_public_path__ + "static/media/pdf-icon.e288ebe5.svg";